/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioHeadphonesIcon24Solid = forwardRef('MediaAudioHeadphonesIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 2C6.477 2 2 6.477 2 12v6.25A2.75 2.75 0 0 0 4.75 21h1.5A2.75 2.75 0 0 0 9 18.25v-4.5A2.75 2.75 0 0 0 6.25 11h-1.5c-.062 0-.124.002-.185.006a7.501 7.501 0 0 1 14.87 0A2.823 2.823 0 0 0 19.25 11h-1.5A2.75 2.75 0 0 0 15 13.75v4.5A2.75 2.75 0 0 0 17.75 21h1.5A2.75 2.75 0 0 0 22 18.25V12c0-5.523-4.477-10-10-10Z" })));
});
